import { httpClient } from '@/services/http/httpClient'
import type { PaginationResponse } from '@/types/paginationResponse'
import { getQueryParams, type QueryParams } from '@/utils/queryParams'
import type { UserStatus } from '../types'

export type UserHttpResponse = {
  id: string
  email: string
  name: string
  status: UserStatus
  departament: {
    id: string
    name: string
  }
  image?: string
  registration?: string
  area?: {
    id: string
    name: string
  }
  isAdmin: boolean
  isManager: boolean
  isProjectAdmin: boolean
}

type GetUsersHttpResponse = {
  users: UserHttpResponse[]
  paginate: PaginationResponse
}

type Params = {
  query: QueryParams
}

export type UserResponse = {
  id: string
  email: string
  name: string
  status: UserStatus
  permissions: string[]
  department: {
    id: string
    name: string
  }
  registration?: string
  avatar?: string
  area?: {
    id: string
    name: string
  }
  isAdmin: boolean
  isManager: boolean
  isProjectAdmin: boolean
}

type GetUsersResponse = {
  users: UserResponse[]
  pagination: PaginationResponse
}

export async function getUsers({ query }: Params): Promise<GetUsersResponse> {
  const queryParams = getQueryParams(query)

  const { data } = await httpClient.get<GetUsersHttpResponse>(
    `/users/?${queryParams}`,
  )

  const { users: usersData = [], paginate } = data

  const users = usersData.map((user: UserHttpResponse) => ({
    id: user.id,
    email: user.email,
    name: user.name,
    status: user.status,
    registration: user.registration,
    permissions: [],
    avatar: user.image,
    area: user.area,
    department: user.departament,
    isAdmin: user.isAdmin,
    isManager: user.isManager,
    isProjectAdmin: user.isProjectAdmin,
  }))

  const pagination = {
    page: paginate.page ?? 1,
    pages: paginate.pages ?? 0,
    total: paginate.total ?? 0,
  }

  return {
    users,
    pagination,
  }
}
